import { AppContext } from '@lightspeed-invoicing/core-client/frontend';
import React, { Component } from 'react';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import { Link, Redirect } from "react-router-dom";
import ActionButton from "../common/button/actionbutton.component.jsx";
import ConfirmButton from '../common/button/confirmbutton.component.jsx';
import LabelSelect from '../common/label/selection.component.jsx';
import TaxSelect from '../common/pricing/taxselect.component.jsx';
import PaymentTermSelect from '../payment-term/locationselect.component.jsx';
import { Guard, Permissions } from '../role/Guard.jsx';
import CompanyInputs from "./companyInputs.component.jsx";

const messages = defineMessages({
    "tax_number_placeholder": {
        id: 'user.form.edit.tax_number',
        defaultMessage: 'Enter Tax number',
    },
})

class CompanyForm extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            advancedForm: true, //by default, we show the short version of the form
            contactId: '',
            contact: null,
            company: {},
            checkValidForm: false,
            isValidForm: true,
            companyDeletedAt: '',
            cancelRedirectPath: this.props.cancelRedirectPath ? props.cancelRedirectPath : '/contacts/listing',
            saveRedirectPath: this.props.saveRedirectPath ? props.saveRedirectPath : '/contacts/listing',
            formStatus: '',
            defaultCountryCode: '',
            labelIds: [],
            customerTypeId: null,
            taxId: '',
            paymentTermId: '',
            isLoading: false,
            taxNumber: '',
        }

        this.save = this.save.bind(this)
        this.saveCompany = this.saveCompany.bind(this)
        this.deleteContact = this.deleteContact.bind(this)
        this.unarchiveContact = this.unarchiveContact.bind(this)
        this.validateCustomerForm = this.validateCustomerForm.bind(this)
    }

    componentDidMount() {
        if (this.props.contactId) {
            AppContext.getApiClient().get('/contacts/' + this.props.contactId).then(company => {
                this.setState({
                    contactId: this.props.contactId,
                    contact: company,
                    companyDeletedAt: company.attributes.deletedAt,
                    labelIds: company.attributes.labelIds,
                    taxId: company.attributes.taxId,
                    paymentTermId: company.attributes.paymentTermId,
                    customerTypeId: company.attributes.labels.filter(l => l.attributes.type === 'customer-type').map(l => l.id)[0] || null,
                    taxNumber: company.attributes.taxNumber,
                })
                return Promise.resolve(null)
            })
        }
    }

    save(event) {
        this.setState({
            isLoading: true,
            checkValidForm: true,
        })

        if (!this.validateCustomerForm() || !this.state.isValidForm) {//prevent saving if the customer form is not filled out properly
            event.preventDefault()
            this.setState({ isLoading: false })
            return
        }


        this.saveCompany().then((response) => {
            let formStatus = ''
            if (response.error) {
                formStatus = <div className="alert alert-danger alert-dismissible fade show" role="alert">
                    <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <FormattedMessage
                        id="customer.modal.add_form.error_message"
                        defaultMessage="Error! {errorMessage}"
                        values={{ errorMessage: response.error.message }}
                    />
                </div>
                this.setState({
                    formStatus: formStatus,
                    isLoading: false,
                    checkValidForm: false
                })
            } else {
                formStatus = <Redirect to={{ pathname: this.state.saveRedirectPath }} />
                this.setState({ formStatus: formStatus, customerId: response.id, isLoading: false, checkValidForm: false })
            }
        })
    }

    validateCustomerForm() {
        let form = document.getElementById("company-form")
        const checkResult = form.checkValidity()
        form.classList.add('was-validated')
        return checkResult
    }

    saveCompany() {
        return AppContext.getApiClient().patch('/organizations/' + this.state.contactId, this.state.company)
    }

    deleteContact(event) {
        AppContext.getApiClient().delete('/contacts/' + this.state.contactId).then((response) => {
            let formStatus = ''
            if (!response.error) {
                formStatus = <Redirect to={{ pathname: '/contacts/listing' }} />
            }
            this.setState({ formStatus: formStatus })
        })

        event.preventDefault()
    }

    unarchiveContact(event) {
        AppContext.getApiClient().put('/contacts/' + this.state.contactId + '/unarchive', {}).then(q => {
            this.setState({
                saveLoading: false,
            })
            this.loadContact(event.getData().contactId)
        })
    }


    render() {
        let deleteAction = []
        if (this.state.companyDeletedAt) {
            deleteAction = [
                <div className="col-3" key={"1"}>
                    <ActionButton className={"btn btn-sm btn-warning mr-2 mb-2"} onClick={this.unarchiveContact}>
                        <FormattedMessage
                            id="customer.form.edit_unarchive_btn"
                            defaultMessage="Unarchive contact"
                        />
                    </ActionButton>
                </div>,
                <div className="col-9" key={"2"}>
                    <FormattedMessage
                        id="customer.edit_form.archived_customer_info"
                        defaultMessage="This contact is archived and can't be found in search results."
                    />
                </div>]
        } else if (this.state.contactId && Guard.isAuthorized(Permissions.DeleteContact)) {
            deleteAction = <ConfirmButton onModalRender={(m, c) => {
                this.setState({ formStatus: m }, c)
            }} onClick={this.deleteContact} className="btn btn-danger" identifier={this.state.contact.attributes.name}>
                <FormattedMessage
                    id="customer.form.edit.delete_btn"
                    defaultMessage="Delete contact"
                />
            </ConfirmButton>
        }

        return (
            <div className="modal-body">
                <div className="container-fluid">
                    <form className="needs-validation" id="company-form" noValidate>
                        <div className="row ui-module">
                            <div className="col-12">
                                <CompanyInputs
                                    advancedForm={true}
                                    changeFormIsValid={(isValidForm) => {
                                        this.setState({ isValidForm: isValidForm })
                                    }}
                                    checkValidForm={this.state.checkValidForm}
                                    contact={this.state.contact}
                                    onChange={c => {
                                        if (this.state.customerTypeId) {
                                            c.labelIds = [this.state.customerTypeId]
                                        }
                                        this.setState({ company: c })
                                    }}
                                />
                                <div className={"form-row "}>
                                    <div className="col-md-12 p-2">
                                        <label htmlFor="customerTypeId">
                                            <FormattedMessage
                                                id="customer.modal.add_form.customer_type_label"
                                                defaultMessage="Customer type"
                                            />
                                        </label>
                                        <LabelSelect
                                            creatable={true}
                                            type="customer-type"
                                            name="customerTypeId"
                                            value={this.state.customerTypeId}
                                            onChange={value => {
                                                const company = this.state.company
                                                company.labelIds = value ? [value] : []
                                                this.setState({
                                                    company: company,
                                                    customerTypeId: value,
                                                })
                                            }}
                                            multi={false}
                                        />
                                    </div>
                                </div>
                                <div className={"form-row "}>
                                    <div className="col-md-12 p-2">
                                        <label htmlFor="contactLanguage">
                                            <FormattedMessage
                                                id="customer.modal.add_form.default_payment_term_label"
                                                defaultMessage="Payment term"
                                            />
                                        </label>
                                        <PaymentTermSelect
                                            value={this.state.paymentTermId}
                                            onChange={paymentTermId => {
                                                const company = this.state.company
                                                company.paymentTermId = paymentTermId
                                                this.setState({
                                                    paymentTermId: paymentTermId,
                                                    company: company,
                                                })
                                            }}
                                            className="form-control"
                                        />
                                    </div>
                                </div>
                                <div className={"form-row "}>
                                    <div className="col-md-12 p-2">
                                        <label htmlFor="contactLanguage">
                                            <FormattedMessage
                                                id="customer.modal.add_form.default_tax_label"
                                                defaultMessage="Default tax"
                                            />
                                        </label>
                                        <TaxSelect
                                            value={this.state.taxId}
                                            onChange={taxId => {
                                                const company = this.state.company
                                                company.taxId = taxId
                                                this.setState({
                                                    taxId: taxId,
                                                    company: company,
                                                })
                                            }}
                                            className="form-control"
                                        />
                                    </div>
                                </div>
                                <div className="col-mb-12 p-2">
                                    <label htmlFor="taxNumber">
                                        <FormattedMessage
                                            id="customer.modal.add_form.contact_tax_id_number_label"
                                            defaultMessage="Tax identification number (optional)"
                                        />
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="taxNumber"
                                        name="taxNumber"
                                        value={this.state.taxNumber}
                                        placeholder={this.props.intl.formatMessage(messages["tax_number_placeholder"])}
                                        onChange={c => {
                                            const company = this.state.company
                                            company.taxNumber = c.target.value
                                            this.setState({
                                                taxNumber: company.taxNumber,
                                                company: company,
                                            })
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </form>
                    <div className="col-12 mb-5">
                        {this.state.formStatus}
                    </div>
                    <div className="row m-0 py-1 fixed-bottom pr-0 pr-md-5 pr-xl-0">
                        <div className={'col-lg-12 mx-auto col-xl-11 pt-3 pl-4 pr-4 pr-md-5 pr-xl-4'}>
                            <div className="col-12 ui-module sticky-bottom-module">
                                <div className="row ">
                                    <div className="col-6 text-align-left">
                                        {deleteAction}
                                    </div>
                                    <div className="col-6 text-align-right">
                                        <Link to={this.state.cancelRedirectPath} className="btn btn-light">
                                            <FormattedMessage
                                                id="product.form.edit.cancel_btn"
                                                defaultMessage="Cancel"
                                            />
                                        </Link>
                                        &nbsp;
                                        &nbsp;
                                        <ActionButton onClick={this.save} className="btn btn-primary" isLoading={this.state.isLoading}>
                                            <FormattedMessage
                                                id="product.form.edit.save_btn"
                                                defaultMessage="Save"
                                            />
                                        </ActionButton>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default injectIntl(CompanyForm);






// WEBPACK FOOTER //
// ./src/customer/companyForm.component.jsx